import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.scss'],
})
export class AccessDeniedComponent {
  readonly fromUrl$ = this.route.queryParamMap.pipe(
    map((params) => params.get('from') ?? '')
  );

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router
  ) {}

  goBack(): void {
    this.router.navigate(['/quotations']);
  }
}
